



























import StudyItem from '../common/study_item.vue'
import { Component, Mixins, Inject, Provide } from 'vue-property-decorator'
import SearchLoadList from '../mixins/LoadList'
import Screen from '../common/search_new_screen.vue'
import { List, Toast, Sticky } from 'vant'
import { namespace } from 'vuex-class'
import { SearchRefresh } from '../searchAll/index.vue'
import { getSearchResult, RequestType } from '../../search-service'
const searchResModule = namespace('searchRes') //vuex
import { studySort } from '@/app/core/constant/search'
@Component({
  components: {
    [List.name]: List,
    [Sticky.name]: Sticky,
    StudyItem,
    Screen
  }
})
export default class SearchProduct extends Mixins(SearchLoadList) {
  @searchResModule.State studySortInfo!: any

  @searchResModule.State studyTypeInfo!: any
  @searchResModule.State studyThemeInfo!: any
  @searchResModule.State studyAgeTypeInfo!: any
  @searchResModule.State studyDirection!: any[]

  @searchResModule.State researchTypes!: any[]
  @searchResModule.State researchThemes!: any[]
  @searchResModule.State researchAgeTypes!: any[]
  @searchResModule.State researchDirections!: any[]
  @searchResModule.State studySelf!: boolean

  @searchResModule.Mutation setResearchStudyNum!: (arg: number | null) => void
  @searchResModule.Mutation selectStudySortInfo!: (arg: any) => void
  @searchResModule.Mutation selectAgeTypeInfo!: (arg: any) => void
  @searchResModule.Mutation selectTypeInfo!: (arg: any) => void
  @searchResModule.Mutation selectThemeInfo!: (arg: any) => void
  @searchResModule.Mutation selectDirection!: (arg: any) => void
  @searchResModule.Mutation selectStudySelf!: (arg: boolean) => void

  @searchResModule.Mutation resetStudy!: () => void //重置筛选项

  @Inject('pageTrackParams')
  pageTrackParams!: any
  @Inject('clickid_200009')
  clickid_200009!: string

  studySort = studySort

  @Provide()
  clickid_200031 = '200031'

  changeSortInfo(e: any) {
    this.selectStudySortInfo(e)
    this.refresh()
  }

  changeAgeTypeInfo(e: any) {
    this.selectAgeTypeInfo(e)
    this.refresh()
  }
  changeTypeInfo(e: any) {
    this.selectTypeInfo(e)
    this.refresh()
  }
  changeThemeInfo(e: any) {
    this.selectThemeInfo(e)
    this.refresh()
  }

  clickDirect(item: any) {
    this.selectDirection(item.ID)
    this.refresh()
  }

  setSelf() {
    this.selectStudySelf(!this.studySelf)
    this.refresh()
  }

  get themePosition() {
    let i = 1
    if (this.researchAgeTypes.length > 1) {
      i++
    }
    if (this.researchTypes.length > 1) {
      i++
    }
    return i
  }

  mounted() {
    const { searchKey = '', tabs = '' } = this.$route.query
    this.keyWord = searchKey as string
    this.tabs = tabs as string
    this.onLoad()
    setTimeout(() => {
      this.$bus.$on(SearchRefresh.RefreshStudy, () => {
        this.refresh()
      })
    }, 1000)
  }

  destroyed() {
    this.$bus.$off(SearchRefresh.RefreshStudy)
  }

  get emptyHeight() {
    const { top, height } = (this.$refs.classify as HTMLElement).getBoundingClientRect() || {}
    return document.body.clientHeight - top - height
  }

  async onLoad() {
    const sortInfo = (this.studySortInfo && this.studySortInfo.ID) || {}
    const screens = { isSelf: this.studySelf ? 1 : '', directionTypes: this.studyDirection || [], themeType: (this.studyThemeInfo && this.studyThemeInfo.ID) || '', researchType: (this.studyTypeInfo && this.studyTypeInfo.ID) || '', ageFilter: (this.studyAgeTypeInfo && this.studyAgeTypeInfo.ID) || '' }
    const result = await getSearchResult({ tabs: this.tabs, keyWords: this.keyWord, type: RequestType.RequestStudy, start: this.start, ...sortInfo, ...screens })
    const { code, data, msg } = result
    if (+code === 1) {
      if (data.cmmdtyInfo) {
        const { total, list: newData = [] } = data.researchStudy
        this.setResearchStudyNum(total)
        if (newData.length < 10) {
          this.finished = true
        }
        this.start = this.start + newData.length
        this.list.push(...newData)
      }
    } else {
      this.errormsg = msg || '加载出错，请稍后再试'
      if (this.list.length > 0) {
        this.error = true
        Toast(this.errormsg)
      }
    }
    this.loading = false
  }

  refresh() {
    this.reset()
    this.$nextTick(() => {
      if (this.isFixed) {
        window.scrollTo(0, this.scrollTop)
      }
    })
    this.onLoad()
  }

  resetCondition() {
    this.resetStudy()
    this.refresh()
  }
}
